import React from 'react';
import styles from './loader.module.css'; // Создайте файл CSS для стилей

export default function Loader() {
  return (
    <div className={styles.spinner}>
  
    </div>
  );
}
